import React from "react";
import SwitchToggle from "../../components/SwitchToggle";
import { useNavigate } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from "recharts";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const dauData = [
  { name: "Mon", users: 600 },
  { name: "Tue", users: 820 },
  { name: "Wed", users: 760 },
  { name: "Thu", users: 900 },
  { name: "Fri", users: 670 },
  { name: "Sat", users: 1020 },
  { name: "Sun", users: 890 },
];

const ViewCampaign = () => {
  const navigate = useNavigate();

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  return (
    <>
      <div className="main_title">
        <h1>Campaign Details</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/marketing")}>
            Marketing Suite
          </button>{" "}
          - Campaign Details
        </p>
      </div>
      <Box className="custom_tabs1" sx={{ width: "100%" }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          aria-label="basic tabs example"
          className="custom_tabs_links tabs_img"
        >
          <Tab label="Basic Information" {...a11yProps(0)} />
          <Tab
            icon={
              <img
                src="/static/images/ai_icon.svg"
                alt=""
                style={{ width: 20, height: 20 }}
              />
            }
            label="Campaign Performance"
            {...a11yProps(1)}
          />{" "}
        </Tabs>
      </Box>
      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="view_page">
            {/* ================= BASIC INFO ================= */}
            <div className="section_box">
              <h2>Basic Information</h2>
              <div className="gap_p">
                <div className="w_33">
                  <h6>Campaign Name</h6>
                  <p>Diwali Mega Sale</p>
                </div>

                <div className="w_33">
                  <h6>Campaign Type</h6>
                  <p>Discount Code</p>
                </div>

                <div className="w_33">
                  <h6>Status</h6>
                  <SwitchToggle />
                </div>

                <div className="w_33">
                  <h6>Start Date</h6>
                  <p>20 November 2025</p>
                </div>

                <div className="w_33">
                  <h6>End Date</h6>
                  <p>30 November 2025</p>
                </div>

                <div className="w_33">
                  <h6>Created Date</h6>
                  <p>10 November 2025</p>
                </div>
                <div className="w_33">
                  <h6>Clicks</h6>
                  <p>50</p>
                </div>
                <div className="w_33">
                  <h6>Conversions</h6>
                  <p>15</p>
                </div>
              </div>
            </div>

            {/* ================= DISCOUNT CODE ================= */}
            <div className="section_box">
              <h2>Discount Code Details</h2>

              <div className="gap_p">
                <div className="w_33">
                  <h6>Apply Discount On</h6>
                  <p>Category</p>
                </div>

                <div className="w_33">
                  <h6>Selected Categories</h6>
                  <p>Electronics, Clothing</p>
                </div>

                <div className="w_33">
                  <h6>Discount Type</h6>
                  <p>Percentage</p>
                </div>

                <div className="w_33">
                  <h6>Discount Value</h6>
                  <p>15%</p>
                </div>

                <div className="w_33">
                  <h6>Minimum Purchase</h6>
                  <p>₹500</p>
                </div>

                <div className="w_33">
                  <h6>Usage Limit</h6>
                  <p>100</p>
                </div>
              </div>
            </div>

            {/* ================= FLASH SALE ================= */}
            <div className="section_box">
              <h2>Flash Sale Details</h2>

              <div className="gap_p">
                <div className="w_33">
                  <h6>Flash Sale Applies On</h6>
                  <p>Specific Products</p>
                </div>

                <div className="w_33">
                  <h6>Flash Products</h6>
                  <p>Laptop, Drone</p>
                </div>

                <div className="w_33">
                  <h6>Flash Start Date</h6>
                  <p>20 November 2025</p>
                </div>

                <div className="w_33">
                  <h6>Flash End Date</h6>
                  <p>25 November 2025</p>
                </div>
              </div>
            </div>

            {/* ================= BUNDLE DEAL ================= */}
            <div className="section_box">
              <h2>Bundle Deal Details</h2>

              {/* Buy X Get Y */}
              <div className="sub_section">
                <h3>Buy X Get Y Free</h3>
                <div className="gap_p">
                  <div className="w_33">
                    <h6>Buy Quantity</h6>
                    <p>2</p>
                  </div>

                  <div className="w_33">
                    <h6>Get Quantity</h6>
                    <p>1</p>
                  </div>

                  <div className="w_33">
                    <h6>Eligible Products</h6>
                    <p>T-shirt, Jeans</p>
                  </div>

                  <div className="w_33">
                    <h6>Free Product Same?</h6>
                    <p>Yes</p>
                  </div>
                </div>
              </div>

              {/* Combo Offer */}
              <div className="sub_section">
                <h3>Combo Offer</h3>
                <div className="gap_p">
                  <div className="w_33">
                    <h6>Products</h6>
                    <p>Laptop, Mouse</p>
                  </div>

                  <div className="w_33">
                    <h6>Bundle Price</h6>
                    <p>₹45,000</p>
                  </div>

                  <div className="w_33">
                    <h6>Original Total</h6>
                    <p>₹52,000</p>
                  </div>
                </div>
              </div>

              {/* Quantity Discount */}
              <div className="sub_section">
                <h3>Quantity Based Discount</h3>
                <div className="gap_p">
                  <div className="w_33">
                    <h6>Minimum Quantity</h6>
                    <p>3</p>
                  </div>

                  <div className="w_33">
                    <h6>Discount Type</h6>
                    <p>Percentage</p>
                  </div>

                  <div className="w_33">
                    <h6>Discount Value</h6>
                    <p>10%</p>
                  </div>
                </div>
              </div>
            </div>

            {/* ================= FREE SHIPPING ================= */}
            <div className="section_box">
              <h2>Free Shipping Details</h2>

              <div className="gap_p">
                <div className="w_33">
                  <h6>Apply On</h6>
                  <p>Location</p>
                </div>

                <div className="w_33">
                  <h6>Locations</h6>
                  <p>India, USA</p>
                </div>

                <div className="w_33">
                  <h6>Start Date</h6>
                  <p>21 November 2025</p>
                </div>

                <div className="w_33">
                  <h6>End Date</h6>
                  <p>30 November 2025</p>
                </div>
              </div>
            </div>

            {/* ================= PREMIUM TOOLS ================= */}
            <div className="section_box">
              <h2>Premium Tools Details</h2>

              {/* Banner Tools */}
              <div className="sub_section">
                <h3>Homepage Banner / Slider / Category Banner</h3>
                <div className="gap_p">
                  <div className="vew_img w_50 no_radius">
                    <h6>Banner Uploaded</h6>
                    <figure>
                      <img alt="user" src="/static/images/placeholder.png" />
                    </figure>
                  </div>

                  <div className="w_50">
                    <h6>Amount</h6>
                    <p>AED 5000</p>
                  </div>
                </div>
              </div>

              {/* Featured Product Tag */}
              <div className="sub_section">
                <h3>Featured Product Tag</h3>
                <div className="gap_p">
                  <div className="w_50">
                    <h6>Selected Product</h6>
                    <p>Laptop</p>
                  </div>

                  <div className="w_50">
                    <h6>Amount</h6>
                    <p>AED 5000</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="campaign-dashboard">
            {/* ===== Stats Row ===== */}
            <div className="campaign-stats">
              <div className="stat-card">
                <span className="stat-label">Impressions</span>
                <span className="stat-value">12,540</span>
                <span className="stat-sub">Total Views</span>
              </div>

              <div className="stat-card">
                <span className="stat-label">Clicks</span>
                <span className="stat-value">1,820</span>
                <span className="stat-sub">Engagement Count</span>
              </div>

              <div className="stat-card">
                <span className="stat-label">Conversions</span>
                <span className="stat-value">134</span>
                <span className="stat-sub success">+7.3% Rate</span>
              </div>

              <div className="stat-card">
                <span className="stat-label">ROI</span>
                <span className="stat-value">4.8×</span>
                <span className="stat-sub info">Return Ratio</span>
              </div>
            </div>

            {/* ===== Row of Performance and Products ===== */}
            <div className="section-row">
              {/* ==== Left: Performance Over Time ==== */}
              <div className="card-large table_container">
                <h3>Performance Over Time</h3>

                {/* Table */}
                <table className="table_container">
                  <thead>
                    <tr>
                      <th>Campaign Name</th>
                      <th>Impressions</th>
                      <th>Clicks</th>
                      <th>Conversions</th>
                      <th>ROI</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Campaign A</td>
                      <td>12,540</td>
                      <td>1,820</td>
                      <td>134</td>
                      <td>4.8×</td>
                    </tr>

                    <tr>
                      <td>Campaign B</td>
                      <td>16,320</td>
                      <td>1,630</td>
                      <td>72</td>
                      <td>4.8×</td>
                    </tr>
                  </tbody>
                </table>

                {/* Chart */}
                <div className="chart-wrapper">
                  <ResponsiveContainer width="100%" height={250}>
                    <BarChart data={dauData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Bar
                        dataKey="users"
                        fill="#D3B88C"
                        radius={[6, 6, 0, 0]}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>

              {/* ==== Right: Top Product Influenced ==== */}
              <div className="card-small table_container">
                <h3>Top Products Influenced</h3>

                <table>
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Impressions</th>
                      <th>Clicks</th>
                      <th>Conv.</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Product A</td>
                      <td>133</td>
                      <td>134</td>
                      <td>7.3%</td>
                    </tr>
                    <tr>
                      <td>Product B</td>
                      <td>98</td>
                      <td>102</td>
                      <td>5.2%</td>
                    </tr>
                  </tbody>
                </table>

                <ul className="insights">
                  <li>Clicks improved by 12% this week</li>
                  <li>ROI is above category average</li>
                  <li>More customers engaged in evenings</li>
                </ul>
              </div>
            </div>
          </div>
        </CustomTabPanel>
      </div>
    </>
  );
};
const cardStyle = {
  flex: "1",
  background: "#f5f5f5",
  borderRadius: "10px",
  padding: "15px 20px",
  border: "1px solid #ddd",
};

const titleStyle = {
  margin: 0,
  fontSize: "14px",
  color: "#555",
  fontWeight: 500,
};

const valueStyle = {
  margin: "5px 0 0",
  fontSize: "20px",
  fontWeight: 700,
  color: "#000",
};
export default ViewCampaign;
